<div class="main-view space-y-2 md:space-y-4">
    <app-page-surface-header titleIcon="bell" title="Notifications" subtitle="Platform alerts and updates" />

    <app-list-module-surface
        [config]="listSurfaceConfig"
        [filters]="listFilters"
        [errorMessage]="listError"
        [loading]="loading"
        [meta]="meta"
        [rowCount]="rows.length"
        (filtersChange)="onListFiltersChange($event)"
        (pageChange)="onListPageChange($event)"
    >
        <ng-container toolbarActions>
            <button
                type="button"
                class="btn rounded-full bg-[#303030] px-5 py-2.5 text-sm font-semibold text-white hover:bg-black disabled:opacity-50 dark:bg-gray-900 dark:hover:bg-black"
                [disabled]="loading || !hasUnread"
                (click)="markAllRead()"
            >
                Mark all read
            </button>
        </ng-container>

        <app-notifications-table
            listTable
            [rows]="rows"
            [loading]="loading"
            (markRead)="onMarkRead($event)"
            (open)="openNotification($event)"
        />
    </app-list-module-surface>
</div>
